import {Component, Inject, OnInit} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
    selector: "business-rules",
    templateUrl: "./business-rules.component.html",
    styleUrls: ["./business-rules.component.scss"],
})
export class BusinessRulesComponent implements OnInit {
    constructor(private route: ActivatedRoute, private fb: FormBuilder) {}

    form: FormGroup;

    displayedColumns: string[] = [
        "ruleTitle",
        "description",
    ];

    rulesets = ['BHANSA AIXM Business Rules'];
    features = ['']
    ruleTitles = ['']

    rules = [
        {
            id: 1,
            title: 'Rule 1',
            description: 'Property X must exist'
        },
        {
            id: 2,
            title: 'Rule 2',
            description: 'Property Y must have value between 10 and 20'
        },
        {
            id: 3,
            title: 'Feature:DesignatedPoint',
            description: 'DesignatedPoint must have either property X or Y but not both.'
        },
        {
            id: 4,
            title: 'Group:PointType',
            description: 'Property group PointType must have both properties X and Y'
        },
        {
            id: 5,
            title: 'Property:DesignatedPointPropertyGroup.type',
            description: 'DesignatedPoint type may not have values A or B'
        }
    ];

    ngOnInit(): void {
        this.form = this.fb.group({
            byRuleset: ['BHANSA AIXM Business Rules'],
            byFeature: [''],
            byTitle: ['']
        });
    }

}
